module.exports = __webpack_public_path__ + "static/media/icn-energetique-moderne.dc4ff8ff.png";